import axios from "@/libraries/Axios";

export const getUserInfo = () => axios.get("/p/user/userInfo")
export const getSecurityToken = () => axios.get("/p/oss/securityToken")
export const getToPayCount = () => axios.get("/p/myOrder/orderCount")
export const setUserInfo = ({avatarUrl,birthDate,nickName,sex}) => axios.put("/p/user/setUserInfo",{avatarUrl,birthDate,nickName,sex})
export const updateUserPassword = ({oldPassword,password}) => axios.put("/p/user/password",{oldPassword,password})
export const addComments = ({param}) => axios.post("/p/prodComm",param)